import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import foto1 from '../../Assets/Image/carousel/carousel3.jpg';
import foto2 from '../../Assets/Image/carousel/carousel1.png';
import foto3 from '../../Assets/Image/carousel/carousel2.png';

const defaultImages = [foto1, foto2, foto3];

const Carousel = ({ images = defaultImages, altPrefix = 'foto' }) => {
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        setCurrentIndex(0);
    }, [images]);

    useEffect(() => {
        if (images.length <= 1) return undefined;
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    const goToPrev = () => {
        setCurrentIndex(currentIndex === 0 ? images.length - 1 : currentIndex - 1);
    };

    const goToNext = () => {
        setCurrentIndex(currentIndex === images.length - 1 ? 0 : currentIndex + 1);
    };

    return (
        <div
            className="carousel"
            style={{
                width: '100%',
                height: '100%',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* Indicators */}
            {images.length > 1 && (
                <div style={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    gap: '10px',
                    zIndex: 10
                }}>
                    {images.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => goToSlide(index)}
                            style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: currentIndex === index ? 'white' : 'rgba(255,255,255,0.5)',
                                cursor: 'pointer'
                            }}
                        />
                    ))}
                </div>
            )}

            {/* Slides */}
            <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                transition: 'transform 0.5s ease'
            }}>
                {images.map((image, index) => (
                    <div
                        key={index}
                        style={{
                            width: '100%',
                            height: '100%',
                            flex: '0 0 100%',
                            transform: `translateX(-${currentIndex * 100}%)`,
                            transition: 'transform 0.5s ease'
                        }}
                    >
                        <img
                            src={image}
                            alt={`${altPrefix} ${index + 1}`}
                            loading={index === 0 ? 'eager' : 'lazy'}
                            decoding="async"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                ))}
            </div>

            {/* Navigation arrows */}
            {images.length > 1 && (
                <>
                    <IconButton
                        aria-label={t('common.previous')}
                        onClick={goToPrev}
                        sx={{
                            position: 'absolute',
                            left: { xs: 6, sm: 10 },
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 10,
                            width: 44,
                            height: 44,
                            color: '#fff',
                            backgroundColor: 'rgba(0,0,0,0.35)',
                            border: '1px solid rgba(255,255,255,0.28)',
                            backdropFilter: 'blur(6px)',
                            WebkitBackdropFilter: 'blur(6px)',
                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.55)' },
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                    <IconButton
                        aria-label={t('common.next')}
                        onClick={goToNext}
                        sx={{
                            position: 'absolute',
                            right: { xs: 6, sm: 10 },
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 10,
                            width: 44,
                            height: 44,
                            color: '#fff',
                            backgroundColor: 'rgba(0,0,0,0.35)',
                            border: '1px solid rgba(255,255,255,0.28)',
                            backdropFilter: 'blur(6px)',
                            WebkitBackdropFilter: 'blur(6px)',
                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.55)' },
                        }}
                    >
                        <ChevronRightIcon />
                    </IconButton>
                </>
            )}
        </div>
    );
};

export default Carousel;
